export default "__VITE_ASSET__CljXFFG0__"